import locale from "localization";

export const rebateType = [
  { label: locale.vipToCash, value: locale.vipToCash },
  { label: locale.todaOrJodaRebates, value: locale.todaOrJodaRebates },
];
